export const testimonialsData = [
    {
        id: 1,
        name: "João Luís",
        course: "Engenharia da Computação - UFBA",
        text: "Estar no ambiente do IMÒLAB é com certeza uma experiência única. O ambiente é incrível, você aprende bastante e tem contato com pessoas que estão dispostas a te ajudar na sua trajetória. Isso sem contar nos diversos projetos que são realizados, como o IMÒLAB TALKS que amplia ainda mais o leque de oportunidades enquanto te enriquece pessoalmente.",
        image: "/testimonials-images/joão.jpg"
    },
    {
        id: 2,
        name: "Bianca Magalhães",
        course: "Secretariado Executivo - UFBA",
        text: "Participar como pesquisadora no ÌMÒLAB e integrar o Programa Nubank de Parceria com a UFBA e o IFBA tem sido uma experiência incentivadora. Aplico meus conhecimentos enquanto aprendo com colegas de diferentes cursos, fortalecendo a conexão entre o Secretariado Executivo e a tecnologia.",
        image: "/testimonials-images/foto_bia.jpg"
    },
    {
        id: 3,
        name: "Ney Márcio",
        course: "Administração - UFBA",
        text: "O ìmòlab é como a casa daquela tia que sempre faz bolo para todos: um lugar acolhedor, onde a gente se sente bem enquanto cresce e cria conexões. Aqui, sinto que minhas contribuições são valorizadas, ao mesmo tempo em que aprendo a fazê-las cada vez melhor.",
        image: "/testimonials-images/ney.jpg"
    },
//         {
//         id: 4,
//         name: "José",
//         course: "Secretariado Executivo - UFBA",
//         text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare.",
//         image: "/Avatar Image.svg"
//     },
//         {
//         id: 4,
//         name: "Amanda",
//         course: "Administração - UFBA",
//         text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare.",
//         image: "/Avatar Image.svg"
//     },
//         {
//         id: 5,
//         name: "Vinicius",
//         course: "Administração - UFBA",
//         text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare.",
//         image: "/Avatar Image.svg"
//     },
//         {
//         id: 6,
//         name: "Matheus",
//         course: "Administração - UFBA",
//         text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare.",
//         image: "/Avatar Image.svg"
//     }
];